import React from 'react';
import classnames from 'classnames';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface ICalendarNoDataCardProps extends IBaseProps {
  placeholder?: string;
}

// 日历卡片无数据时的宽度
export const CALENDAR_EMPTY_CARD_WIDTH = 100;
export const CALENDAR_NO_DATA_CARD_WIDTH = CALENDAR_EMPTY_CARD_WIDTH;

const CalendarNoDataCard: React.FC<ICalendarNoDataCardProps> = (props) => {
  const { style, className, placeholder = 'No Data' } = props;

  return (
    <div
      style={{ ...style, width: CALENDAR_EMPTY_CARD_WIDTH }}
      className={classnames('dbg-calendar-no-data-card', className)}
    >
      <span>{placeholder}</span>
    </div>
  );
};

export default CalendarNoDataCard;
